import React from 'react';
import { useFormContext } from 'react-hook-form';
import { ModalWizardNavItem } from '@panwds/react-ui';
import { useFormStatus } from './useFormStatus.esm.js';

function WizardFormNavItem({ onClick, ...passThrough }) {
    const { getValues } = useFormContext();
    const status = useFormStatus();
    return (React.createElement(ModalWizardNavItem, { onClick: () => {
            onClick({ status, values: getValues() });
        }, ...passThrough }));
}

export { WizardFormNavItem };
//# sourceMappingURL=NavItem.esm.js.map
